// Invoices

// client types produces a string, backend has an enum
// https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/CommerceBillingPortal/-/blob/CommerceBillingPortalModels/src/main/java/com/hubspot/commerce/billing/portal/models/invoice/InvoiceStatus.java
export const INVOICE_STATUS = {
  DRAFT: 'DRAFT',
  OPEN: 'OPEN',
  PAID: 'PAID',
  VOIDED: 'VOIDED',
  PAST_DUE: 'PAST_DUE'
};
export const invoiceStatusToStatusTagUse = {
  [INVOICE_STATUS.OPEN]: 'warning',
  [INVOICE_STATUS.PAST_DUE]: 'error',
  [INVOICE_STATUS.PAID]: 'success',
  [INVOICE_STATUS.DRAFT]: 'default',
  [INVOICE_STATUS.VOIDED]: 'info'
};
export const invoiceStatusToStatusTagMessage = {
  [INVOICE_STATUS.OPEN]: 'invoices.status.open',
  [INVOICE_STATUS.PAST_DUE]: 'invoices.status.pastDue',
  [INVOICE_STATUS.PAID]: 'invoices.status.paid',
  [INVOICE_STATUS.DRAFT]: 'invoices.status.draft',
  [INVOICE_STATUS.VOIDED]: 'invoices.status.voided'
};

// client types produces a string, backend has an enum
// https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/CommerceBillingPortal/-/blob/CommerceBillingPortalModels/src/main/java/com/hubspot/commerce/billing/portal/models/invoice/InvoiceFrequencyType.java

export const INVOICE_FREQUENCY_TYPE = {
  RECURRING: 'RECURRING',
  ONE_TIME: 'ONE_TIME'
};
export const invoiceFrequencyTypeToTypeMessage = {
  [INVOICE_FREQUENCY_TYPE.RECURRING]: 'invoices.frequencyType.recurring',
  [INVOICE_FREQUENCY_TYPE.ONE_TIME]: 'invoices.frequencyType.oneTime'
};

// Subscriptions

// client types prdouces a string, backend has an enum
// https://sourcegraph.hubteam.com/git.hubteam.com/HubSpot/CommerceBillingPortal/-/blob/CommerceBillingPortalModels/src/main/java/com/hubspot/commerce/billing/portal/models/subscription/SubscriptionStatus.java
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  UNPAID: 'UNPAID',
  SCHEDULED: 'SCHEDULED',
  PAUSED: 'PAUSED'
};
export const subscriptionStatusToStatusBadgeUse = {
  [SUBSCRIPTION_STATUS.ACTIVE]: 'oz',
  [SUBSCRIPTION_STATUS.INACTIVE]: 'koala',
  [SUBSCRIPTION_STATUS.UNPAID]: 'lorax',
  [SUBSCRIPTION_STATUS.SCHEDULED]: 'pantera',
  [SUBSCRIPTION_STATUS.PAUSED]: 'marigold'
};
export const subscriptionStatusToStatusBadgeMessage = {
  [SUBSCRIPTION_STATUS.ACTIVE]: 'subscriptions.status.active',
  [SUBSCRIPTION_STATUS.INACTIVE]: 'subscriptions.status.inactive',
  [SUBSCRIPTION_STATUS.UNPAID]: 'subscriptions.status.unpaid',
  [SUBSCRIPTION_STATUS.SCHEDULED]: 'subscriptions.status.scheduled',
  [SUBSCRIPTION_STATUS.PAUSED]: 'subscriptions.status.paused'
};

// Payment Methods

export const PAYMENT_METHOD_TYPE = {
  CARD: 'CARD',
  ACH: 'ACH',
  BACS: 'BACS',
  PADS: 'PADS',
  SEPA: 'SEPA'
};